var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74087 5.572L9.6181 2.38559C9.7599 1.87147 10.5029 1.87147 10.6447 2.38559L11.4898 5.45549C11.9208 7.02557 13.1743 8.24983 14.7794 8.67333L17.5264 9.39643C18.1579 9.56287 18.1579 10.4394 17.5264 10.6077L14.8815 11.3049C13.214 11.7451 11.9114 13.0193 11.4614 14.6504L10.6466 17.613C10.5048 18.129 9.75801 18.129 9.61621 17.613L8.90346 15.0221C8.39111 13.1617 6.90512 11.7062 5.0013 11.2051L2.40553 10.5208C1.86482 10.3784 1.86482 9.62759 2.40553 9.48519L5.60251 8.64374C7.13388 8.24059 8.32872 7.07181 8.74087 5.57384V5.572Z",
    fill: "current",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/sparkle.47c1d8ab58d6d7374f8db4b23a009fb6.svg";
export { ForwardRef as ReactComponent };